import { themes } from './index';

export interface ITheme {
  [key: string]: string;
}

export interface IThemes {
  [key: string]: ITheme;
}

export interface IMappedTheme {
  [key: string]: string | null;
}

export const mapTheme = (variables: ITheme): IMappedTheme => {
  return {
    '--font-primary': variables.font || '',
    '--color-primary': variables.primary || '',
    '--color-secondary': variables.secondary || '',
    '--color-positive': variables.positive || '',
    '--color-negative': variables.negative || '',
    '--color-text-primary': variables.textPrimary || '',
    '--background-primary': variables.backgroundPrimary || '',
    '--background-secondary': variables.backgroundSecondary || '',
    '--background-primary-lighten': variables.backgroundPrimaryLighten || '',
    '--background-secondary-lighten': variables.backgroundSecondaryLighten || '',
    '--background-hover': variables.backgroundHover || '',
  };
};

export const extend = (extending: ITheme, newTheme: ITheme): ITheme => {
  return { ...extending, ...newTheme };
};

/**
 * Helper function to set a new theme
 *
 * @param {string} theme The name of the theme to be set
 *
 * @return {void}
 */
export const applyTheme = (theme: string | ITheme): void => {
  const currentTheme: string | ITheme = typeof theme === 'string' ? themes[theme] : theme;
  const themeObject: IMappedTheme = mapTheme(currentTheme);
  if (!themeObject) return;
  const root = document.documentElement;

  Object.keys(themeObject).forEach((property) => {
    if (property === 'name') {
      return;
    }

    root.style.setProperty(property, themeObject[property]);
  });

  // Load Google Font if provided
  if (currentTheme?.font) {
    const fontName = currentTheme.font.replace(/ /g, '+');
    const fontId = `google-font-${fontName}`;

    if (!document.getElementById(fontId)) {
      console.log('ADDING FONTS', currentTheme?.font);
      const link = document.createElement('link');
      link.id = fontId;
      link.rel = 'stylesheet';
      link.href = `https://fonts.googleapis.com/css2?family=${fontName}:wght@300;400;500;600;700&display=swap`;
      document.head.appendChild(link);
    }
  }
};

export function colorLuminance(hex: any, lum: number) {
  // Validate hex string
  hex = String(hex).replace(/[^0-9a-f]/gi, '');
  if (hex.length < 6) {
    hex = hex.replace(/(.)/g, '$1$1');
  }
  lum = lum || 0;
  // Convert to decimal and change luminosity
  let rgb = '#',
    c;
  for (let i = 0; i < 3; ++i) {
    c = parseInt(hex.substr(i * 2, 2), 16);
    c = Math.round(Math.min(Math.max(0, c + c * lum), 255)).toString(16);
    rgb += `00${c}`.substr(c.length);
  }
  return rgb;
}
